const markHelpful = function() {

	const cookieKey = 'pickard_marked_faqs';

	const getCookieVal = function(name) {

		const cookie = document.cookie
			.split('; ')
			.find(row => row.startsWith(name+'='));

		if ( cookie ) {
			return JSON.parse( cookie.split('=')[1] );
		} else {
			return [];
		}
	}

	const updateCookie = function(type, id) {

		let cookieVal = getCookieVal(cookieKey);

		if ( ! cookieVal.length ) {
			cookieVal.push( id );
		} else {
			if ( 'mark' === type && ! cookieVal.includes( id ) ) {
				cookieVal.push( id );
			}
			if ( 'unmark' === type && cookieVal.includes( id ) ) {
				cookieVal = cookieVal.filter(function(v, i, a) {
					return v != id;
				});
			}
		}

		const expiryDate = new Date();
		expiryDate.setMonth(expiryDate.getMonth() + 24);

		document.cookie = cookieKey + '=' + JSON.stringify( cookieVal ) + ';expires=' + expiryDate + 'samesite=strict;secure';
	}

	const updateStar = function(type,item) {

		if ( 'mark' === type ) {
			item.classList.add('rated');
		} else {
			item.classList.remove('rated');
		}
	}

	// Listen for mark/unmark interactions and update state.
	document.querySelectorAll('.js-mark-helpful').forEach(item => {

		item.addEventListener('click', () => {

			const id = item.getAttribute('data-faq-id');

			if ( ! id ) {
				return;
			}

			const type = ( item.classList.contains('rated') ) ? 'unmark': 'mark';

			fetch(
				ajaxSettings.ajaxURL,
				{
					method: 'POST',
					credentials: 'same-origin',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded',
						'Cache-Control': 'no-cache',
					},
					body: new URLSearchParams({
						action: 'maybe_mark_faq_helpful',
						nonce: ajaxSettings.ajaxNonce,
						id,
						type,
					})
				}
			).then(response => response.json())
				.then(response => {
					if ( response.success ) {
						updateCookie(type, id);
						updateStar(type,item);
					}
				})
				.catch(err => console.log(err));
		})
	});

	// Update marked state on document load.
	window.addEventListener('load', (event) => {

		const markHelpfulEls = document.querySelectorAll('.js-mark-helpful');

		if ( ! markHelpfulEls ) {
			return;
		}

		markHelpfulEls.forEach(item => {

			const id = item.getAttribute('data-faq-id');

			if ( ! id ) {
				return;
			}

			const cookieVal = getCookieVal(cookieKey);

			if ( ! cookieVal ) {
				return;
			}

			if ( cookieVal.includes( id ) && ! item.classList.contains('rated') ) {
				updateStar('mark', item);
			}
		});

	});
}
export default markHelpful;
